module.exports = __webpack_public_path__ + "media/products/car2-df040e62.png";